import { render, staticRenderFns } from "./RequestPresentationForm.vue?vue&type=template&id=2aa0c601&scoped=true&"
import script from "./RequestPresentationForm.vue?vue&type=script&lang=js&"
export * from "./RequestPresentationForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestPresentationForm.vue?vue&type=style&index=0&id=2aa0c601&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0c601",
  null
  
)

export default component.exports